import countryStateCity from "country-state-city.js";

const getCountry = (idCountry) => {
    if (!(typeof idCountry === 'string') || (idCountry === '')) return null;

    const country = countryStateCity[idCountry];
    if (!country) return null;

    return country;
}

const getAllStatesOfCountry = (idCountry) => {
    // console.log('##getAllStatesOfCountry', getCountry(idCountry))
    const states = getCountry(idCountry)?.states ?? null;

    return states;
}

const getState = (idState, idCountry) => {
    if (!(typeof idState === 'string') || (idState === '')) return null;

    const states = getAllStatesOfCountry(idCountry);
    const state = states?.find(state=> state.isoCode === idState) ?? null;

    return state;
}

const getAllCitiesOfState = (idState, idCountry) => {
    // console.log('##getAllCitiesOfState', idState, idCountry);
    const cities = getState(idState, idCountry)?.cities ?? null;

    return cities;
}

const sortListOfObjects = (type, list, order, key) => {
  return list.sort((a, b) => {
    // utility function to get the nested keys
    const getValue = (obj, nestedKey) => nestedKey.split('.').reduce((acc, part) => acc && acc[part], obj)
    const valA = getValue(a, key), valB = getValue(b, key)
    if (type === "string") {
      const strA = String(valA).toLowerCase();
      const strB = String(valB).toLowerCase();
      return order === "asc" ? strA.localeCompare(strB) : strB.localeCompare(strA);
    }
    if (type === "number") {
      const numA = parseFloat(valA);
      const numB = parseFloat(valB);
      return order === "asc" ? numA - numB : numB - numA;
    }
    return 0;
  });
};

export {
    getCountry,
    getState,
    getAllStatesOfCountry,
    getAllCitiesOfState,
    sortListOfObjects,
}
